module.exports = __webpack_public_path__ + "ed082f66af8101e017fe940f4133604e.png";